import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function MinhaConta() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        birthDate: ''
    });
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        // Fetch user profile data
        const fetchProfile = async () => {
            try {
                const response = await api.get('/auth/me');

                setFormData({
                    name: response.data.name || '',
                    email: response.data.email || '',
                    phone: response.data.phone || response.data.phoneNumber || '',
                    birthDate: response.data.birthDate || ''
                });
            } catch (error) {
                console.error("Error fetching profile:", error);
                // Fallback to localStorage if API fails (or for initial dev)
                const storedName = localStorage.getItem('userName');

                setFormData(prev => ({
                    ...prev,
                    name: storedName || prev.name,
                    email: prev.email || 'usuario@exemplo.com'
                }));
            } finally {
                setFetching(false);
            }
        };

        fetchProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhoneChange = (value) => {
        setFormData(prev => ({
            ...prev,
            phone: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.put('/auth/profile', {
                name: formData.name,
                phone: formData.phone
            });

            if (formData.name) {
                localStorage.setItem('userName', formData.name);
            }
            alert('Perfil atualizado com sucesso!');
            window.location.reload();
        } catch (error) {
            console.error(error);
            alert('Erro ao atualizar dados. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return <div style={{ padding: '2rem', textAlign: 'center' }}>Carregando perfil...</div>;
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="form-container" style={{ width: '100%' }}>
                <h2 style={{ marginBottom: '1.5rem' }}>Minha Conta</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nome Completo</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            disabled
                            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed', color: '#666' }}
                        />
                        <small style={{ color: '#999' }}>O email não pode ser alterado.</small>
                    </div>

                    <div className="form-group highlight-input">
                        <label>WhatsApp / Telefone</label>
                        <PhoneInput
                            country={'br'}
                            value={formData.phone}
                            onChange={handlePhoneChange}
                            inputStyle={{ width: '100%', height: '40px' }}
                            containerStyle={{ width: '100%' }}
                            placeholder="(00) 00000-0000"
                        />
                    </div>

                    {/* Optional: Birth Date if needed */}
                    {/* 
                    <div className="form-group">
                        <label>Data de Nascimento</label>
                        <input
                            type="date"
                            name="birthDate"
                            value={formData.birthDate}
                            onChange={handleChange}
                        />
                    </div> 
                    */}

                    <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar Alterações'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default MinhaConta;
